import { FeatureFlag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import useFeature from '@swf/core/hooks/useFeature';
import { select } from '@swf/core/store';

import { HGToastType } from '../../types/common';
import ToastMessage from '../ToastMessage/ToastMessage';

import { TXTCLI_You_canXt_join_public_clubs_in_ELL } from './JoinAndCreateClubToast.messages.json';
import styles from './JoinAndCreateClubToast.scss';

const JoinAndCreateClubToast: React.FC = () => {
  const { homegames } = useSelector(select.localSettings.get);

  const isPublicClubJoinAndCreateEnabled = useFeature(
    FeatureFlag.PKRHomeGamesJoinAndCreatePublicClubs
  );

  const isHiddenToastMessage =
    homegames?.toastMessage?.[HGToastType.JoinAndCreateClubToast]?.isHidden;

  return !isPublicClubJoinAndCreateEnabled && isHiddenToastMessage === false ? (
    <ToastMessage id={HGToastType.JoinAndCreateClubToast}>
      <div className={styles.toastText}>
        <Translation {...TXTCLI_You_canXt_join_public_clubs_in_ELL} />
      </div>
    </ToastMessage>
  ) : null;
};

export default JoinAndCreateClubToast;
